<script>

import 'bootstrap-vue/dist/bootstrap-vue.css'
import functions from '../../mixins/import/summary.js';

export default {
	mixins: [functions],
	props: ['id', 'rows', 'mappedColumns'],
	data() {
		return {
			fields: [
				{ key: 'first_name', label: 'First name', sortable: true, sortDirection: 'asc' },
				{ key: 'last_name', label: 'Last name', sortable: true, sortDirection: 'asc' },
				{ key: 'phone', label: 'Phone', sortable: true, sortDirection: 'asc' },
				{ key: 'email', label: 'Email', sortable: true, sortDirection: 'asc' },
				{ key: 'address', label: 'Address', sortable: true, sortDirection: 'asc' },
				{ key: 'city', label: 'City', sortable: true, sortDirection: 'asc' },
				{ key: 'postal_code', label: 'Postal code', sortable: true, sortDirection: 'asc' },
				{ key: 'note', label: 'Note', sortable: true, sortDirection: 'asc' },
				{ key: 'sms_marketing_agreement', label: 'Sms marketing', sortable: true, sortDirection: 'asc' },
				{ key: 'email_marketing_agreement', label: 'Email marketing', sortable: true, sortDirection: 'asc' }
			],

			totalRows: 0,
			currentPage: 1,
			search: null,
			sortBy: 'first_name',
			sortDesc: false,
			perPage: 15
		}
	},
	mounted() {

		if (this.mappedColumns.includes('address') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'address');
		}

		if (this.mappedColumns.includes('city') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'city');
		}

		if (this.mappedColumns.includes('postal_code') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'postal_code');
		}

		if (this.mappedColumns.includes('note') === false) {
			this.fields = this.fields.filter(function(value) {
				return (value.key !== this);
			}, 'note');
		}

		this.totalRows = this.rows.length;
	},
	methods: {
		downloadFile()
		{
			let open = window.open('/import/' + this.id + '/download-file', '_blank');

			if (open == null || typeof(open) === 'undefined') {
				alert('Turn off your pop-up blocker!');
			}
		}
	}
}
</script>